export default function tabs() {

    // Инициализация всех систем табов на странице
    function initTabSystems() {
        // Находим все контейнеры с табами
        const tabContainers = document.querySelectorAll('.js-tab-btns[data-tab-addiction]');
        
        tabContainers.forEach(container => {
            const addictionName = container.getAttribute('data-tab-addiction');
            
            // Находим кнопки табов и соответствующие блоки контента
            const tabLinks = container.querySelectorAll('.js-tab-link');
            const tabBoxes = document.querySelectorAll(
                `.js-tab-box[data-tab-addiction="${addictionName}"]`
            );

            // Функция переключения табов
            function switchTab(event) {
                event.preventDefault();
                const clickedLink = event.currentTarget;
                const tabNumber = clickedLink.getAttribute('data-tab-number');
                
                // Удаляем класс active у всех кнопок этой группы
                tabLinks.forEach(link => link.classList.remove('active'));
                
                // Добавляем класс active текущей кнопке
                clickedLink.classList.add('active');
                
                // Удаляем класс active у всех связанных блоков контента
                tabBoxes.forEach(box => box.classList.remove('active'));
                
                // Находим и активируем соответствующий блок контента
                const activeBox = document.querySelector(
                    `.js-tab-box[data-tab-addiction="${addictionName}"][data-tab-number="${tabNumber}"]`
                );
                
                if (activeBox) {
                    activeBox.classList.add('active');
                }
            }

            // Назначаем обработчики клика на кнопки табов
            tabLinks.forEach(link => {
                link.addEventListener('click', switchTab);
            });

            // Активируем первый таб, если нет активного
            const hasActive = container.querySelector('.js-tab-link.active');
            if (!hasActive && tabLinks.length > 0) {
                tabLinks[0].click();
            }
        });
    }

    // Инициализируем системы табов
    initTabSystems();



}